import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type FormGridColumns = 1 | 2 | 3
type FormGridColSpan = 1 | 2 | 3
type FormGridGap = 'sm' | 'md' | 'lg'

interface FormGridProps {
    children: ReactNode
    columns?: FormGridColumns
    /** Grid-column span inside a parent grid (for nested layouts). */
    colSpan?: FormGridColSpan
    /** Gap between grid children. Defaults to `md` (gap-4). */
    gap?: FormGridGap
    className?: string
}

 
const COLS_CLASS: Record<FormGridColumns, string> = {
    1: '',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
}

const COL_SPAN_CLASS: Record<FormGridColSpan, string> = {
    1: '',
    2: 'col-span-2',
    3: 'col-span-3',
}

const GAP_CLASS: Record<FormGridGap, string> = {
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
}
 

export function FormGrid({children, columns = 1, colSpan, gap = 'md', className}: FormGridProps) {
    return (
        <div
            className={cn(
                'grid',
                GAP_CLASS[gap],
                COLS_CLASS[columns],
                colSpan !== undefined && COL_SPAN_CLASS[colSpan],
                className,
            )}
        >
            {children}
        </div>
    )
}
